import styled from '@emotion/styled';
import { brandNeutralColors, colors } from '@anyroad/theme';
import { Theme } from 'ui_system/theme';

export const Container = styled.div<{ borderless?: boolean }>`
  border-bottom: 1px solid ${brandNeutralColors.border};
  border-top: ${(props) =>
    props.borderless ? '0' : `1px solid ${brandNeutralColors.border}`};
  padding-bottom: 50px;
  margin-top: 40px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
`;

export const Wrapper = styled.div<{ noMobilePadding?: boolean }>`
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    text-align: center;
    padding-left: 20px;
    padding-top: 15px;
    padding-right: 0;
  }

  ${(props) => props.noMobilePadding && 'padding-left: 0 !important;'}
`;

export const HeaderRow = styled.div<{ isPhone: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => (props.isPhone ? '33px 1fr' : '1fr')};
  align-items: center;
  margin-left: 0;
`;

export const Toggle = styled('span')`
  font-size: 23px;
  color: ${brandNeutralColors.text.icon};
  line-height: 37px;
  text-align: left;
`;

export const Header = styled.h2<{ isPhone: boolean }>`
  margin: 0;
  text-align: ${(props) => (props.isPhone ? 'left' : 'center')};
`;

export const Hint = styled.div`
  color: ${brandNeutralColors.text.secondary};
  padding-bottom: 16px;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 5px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    text-align: left;
    justify-content: flex-start;
    min-height: 40px;
    padding-left: 0;
  }
`;

export const HintIcon = styled.div`
  svg {
    fill: ${colors.primary};
    font-size: 1.5em;
    margin-right: 5px;
    top: 4px;
  }
`;

export const HintText = styled.div`
  max-width: 400px;
  text-align: left;
`;

export const Reveal = styled('div')<{ show: boolean }>`
  height: ${(props) => (props.show ? 'auto' : '0')};
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

export const TextAreaWrapper = styled.div`
  width: 60%;
`;
